import request from "@/utils/request";

export function getQualificationCarList() {
  return request({
    url: "/car/qualificationInfo/getQualificationCarList",
    method: "get",
  });
}

export function getZoneListByQualification(qualificationId, testType) {
  return request({
    url: `/test/zoneInfo/getZoneListByQualification?qualificationId=${qualificationId}&testType=${testType}`,
    method: "get",
  });
}

export function getPersonListByQualificationId(qualificationId, personType) {
  return request({
    url: `/person/manage/getPersonListByQualificationId?personType=${personType}&qualificationId=${qualificationId}`,
    method: "get",
  });
}

export function getTestZoneDetailsByCondition(data) {
  return request({
    url: `/test/zoneDetailInfo/getTestZoneDetailsByCondition`,
    method: "post",
    data: data,
  });
}

export function checkCarChangeApply(carId) {
  return request({
    url: `/cloud/carChangeApplyEntity/checkCarChangeApply?carId=${carId}`,
    method: "get",
  });
}

export function save(data) {
  return request({
    url: `/test/taskInfo/save`,
    method: "post",
    data: data,
  });
}

export function checkTestTaskTimeScope(data) {
  return request({
    url: `/test/taskInfo/checkTestTaskTimeScope`,
    method: "post",
    data: data,
  });
}

export function detailCarInfoById(id) {
  return request({
    url: `/test/taskInfo/detailCarInfoById?id=${id}`,
    method: "get",
  });
}

export function detailTestTaskZoneInfoById(id) {
  return request({
    url: `/test/taskInfo/detailTestTaskZoneInfoById?id=${id}`,
    method: "get",
  });
}

export function detailTestTaskPersonInfoById(id) {
  return request({
    url: `/test/taskInfo/detailTestTaskPersonInfoById?id=${id}`,
    method: "get",
  });
}
